import * as url from 'url';
import bootstrapBrowser from './browser';
import {isIonicWebView} from '../engine'

const CORDOVA_PATH_KEY = 'cordova_runtime_path';

/**
 * Returns the cordova.js.
 * Try to load first the location stored and if not found, load
 * the cordova relative to the current location.
 *
 * @return {string}
 */
function getCordovaRuntimePath() {
    // save path relative to cordova.js if not setted....
    if(isIonicWebView()){
        return 'ionic://localhost/cordova.js';
    }else{
        let path = window.localStorage.getItem(CORDOVA_PATH_KEY);
        if (!path) {
            return url.resolve(document.location.href, './cordova.js');
        } else {
            return path;
        }
    }
}

function getSrcCordova(){
    if(isIonicWebView()){
        return 'ionic://localhost/cordova.js';
    }else{
        return url.resolve(document.location.href, './cordova.js');
    }
}

/**
 * Save the cordova location represented by the path parameter
 * @param {string} path the cordova full location
 */
function saveCordovaLocation(path) {
    window.localStorage.setItem(CORDOVA_PATH_KEY, path);
}

/**
 * Resolves after `cordova.js` has been injected and loaded onto the body
 * @type {Promise<void>}
 */
function loadCordovaRuntime() {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = getCordovaRuntimePath();
        script.async = true;
        script.onload = () => {
            saveCordovaLocation(script.src);
            resolve();
        };
        script.onerror = () => {

            console.warn(`the file: ${script.src} not exists, its a new update from the store and we must load the original one and save it`);

            const scriptBackward= document.createElement('script');
            scriptBackward.type = 'text/javascript';
            scriptBackward.src = getSrcCordova();
            scriptBackward.async = true;
            scriptBackward.onload = () => {
                saveCordovaLocation(scriptBackward.src);
                resolve();
            };

            scriptBackward.onerror = () => reject(new Error(`Couldn't load cordova runtime at ${scriptBackward.src}`));
            document.getElementsByTagName('head')[0].appendChild(scriptBackward);
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    })
}


/**
 * Resolves after the `'deviceready'` event gets fired.
 * @type {Promise<void>}
 */
function afterDeviceReady() {
    return new Promise((resolve) => {
        const listener = () => {
            document.removeEventListener('deviceready', listener, false);
            window.open = cordova.InAppBrowser.open;
            resolve();
        }
        document.addEventListener('deviceready', listener, false);
    });
}

export default function bootstrapCordova() {
    return bootstrapBrowser()
    .then(() => Promise.all([ loadCordovaRuntime(), afterDeviceReady()]))
    .then(() => console.log("Cordova Ready"))
}



// WEBPACK FOOTER //
// ./src/shared/engine-dynamic/engines/cordova.js